import Index from './index.vue'

export default {
  name: 'potentialProfile',
  path: '/v-admin/potential/profile',
  component: Index,
  meta: {
    isInclude: true,
    permission: 'PREMIUM_SOFT_USER',
    titleI18nKey: 'admin.talent.pool.potential'
  },
  children: [
    {
      path: '/v-admin/talent-pool/:talentFilterGroupId/candidate/:potentialId/potential-profile/:pageType?',
      component: Index,
      meta: {
        permission: 'PREMIUM_SOFT_USER',
        titleI18nKey: 'admin.application.candidate.title.referral'
      }
    },
    {
      path: '/v-admin/job/:jobId/candidate/:potentialId/potential-profile/:pageType?',
      component: Index,
      meta: {
        permission: 'PREMIUM_SOFT_USER',
        titleI18nKey: 'admin.application.candidate.title.referral'
      }
    }
  ]
}
